import React, { Component } from 'react'
import styled from 'styled-components'

import logoBrown from '../../assets/images/logo-brown.png'

import { bgImage, bgIcon } from '../../styles/global'
import { isClient } from '../../styles/utils'
import { media } from '../../styles/utils'


const SPLASH_DURATION_MS = 5000
const SESSION_KEY = 'introSeen'


// Site-wide first-visit splash overlay. Shows the home hero image full-screen,
// fades out after ~5s (or on click), and doesn't re-appear during the session.
class Splash extends Component {

    state = {
        // Rendered but invisible during SSR; componentDidMount decides whether
        // to actually show it. Avoids a splash flash on hydration for repeat visits.
        active: false,
        mounted: false,
    }

    componentDidMount() {
        let seen = false
        try { seen = !!sessionStorage.getItem(SESSION_KEY) } catch (e) {}

        if (seen) {
            this.setState({ mounted: true, active: false })
            return
        }

        this.setState({ mounted: true, active: true })
        this.timer = setTimeout(this.dismiss, SPLASH_DURATION_MS)
    }

    componentWillUnmount() {
        clearTimeout(this.timer)
    }

    dismiss = () => {
        clearTimeout(this.timer)
        try { sessionStorage.setItem(SESSION_KEY, '1') } catch (e) {}
        this.setState({ active: false })
    }

    extractHeroImage() {
        const { heroImage, homeAcfJson } = this.props
        if (heroImage) return heroImage
        if (!homeAcfJson) return null

        try {
            const acf = JSON.parse(homeAcfJson)

            if (acf.hero_image && acf.hero_image.sizes) {
                return acf.hero_image.sizes.full_width
                    || acf.hero_image.sizes.large
                    || acf.hero_image.url
            }

            if (acf.sections && acf.sections.length) {
                for (let s = 0; s < acf.sections.length; s++) {
                    const blocks = acf.sections[s].blocks || []
                    for (let b = 0; b < blocks.length; b++) {
                        const block = blocks[b]
                        const img = block.image || block.hero_image || block.background_image
                        if (img && img.sizes) {
                            return img.sizes.full_width || img.sizes.large || img.url
                        }
                    }
                }
            }
        } catch (e) {}
        return null
    }

    render() {
        // Skip during SSR to avoid the interstitial appearing in the initial HTML.
        if (!isClient() || !this.state.mounted) return null

        const image = this.extractHeroImage()
        if (!image) return null

        return (
            <Wrapper
                active={this.state.active}
                onClick={this.dismiss}
            >
                <Image image={image} />
                <Logo />
            </Wrapper>
        )
    }
}


const Wrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 13;
    background: #FFFFFF;
    transition: opacity 0.9s ease;

    opacity: ${props => (props.active ? 1 : 0)};
    pointer-events: ${props => (props.active ? 'auto' : 'none')};
`

const Image = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url(${props => props.image});
    ${bgImage}
`

const Logo = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    width: 374px;
    height: 40px;
    margin-left: -187px;
    margin-top: -20px;
    background-image: url(${logoBrown});
    ${bgIcon}

    ${media.tablet`
        width: 280px;
        height: 30px;
        margin-left: -140px;
        margin-top: -15px;
    `}

    ${media.phone`
        width: 220px;
        height: 24px;
        margin-left: -110px;
        margin-top: -12px;
    `}
`


export default Splash



// WEBPACK FOOTER //
// ./src/components/Splash/Splash.js